import { all } from "redux-saga/effects";
import authSagas from "./Auth";
import notesSagas from "./Notes";
//import servicesSagas from "./Service";

export default function* rootSaga(getState) {
  yield all([authSagas(), notesSagas() /*, servicesSagas()*/]);
}
